<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :rules="rulesFormAddTypeSupply"
        :submit="handleSubmitFormAddTypeSupply"
        :custom="['header', 'footer']"
        @close="closeOverSide">
        <template #header>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-header">
                    <h3 class="title">
                        <hi-plus-circle-icon class="icon" />
                        <span class="label">
                            {{ $t('labels.addTypeSupply') }}
                        </span>
                    </h3>
                    <button
                        class="button_close"
                        @click="closeOverSide">
                        <hi-x-mark-icon
                            class="h-6 w-6"
                            aria-hidden="true" />
                    </button>
                </div>
            </div>
        </template>

        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-body">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <hi-backward-icon class="icon overturned" />
                                <span class="label">
                                    {{ $t('labels.generalInformation') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-4"
                            :class="columnClass">
                            <hts-form-input
                                v-model="dataFormAddTypeSupply.typeSupplyName"
                                :label="$t('labels.typeSupplyName')"
                                :required="true"
                                :color="props.color"
                                name="typeSupplyName"
                                prop="typeSupplyName" />
                            <hts-form-input
                                v-model="dataFormAddTypeSupply.description"
                                :required="true"
                                :label="$t('labels.description')"
                                :color="props.color"
                                name="description"
                                prop="description" />
                        </div>
                    </hts-card>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-footer">
                    <div class="footer">
                        <div class="footer-left">
                            <hts-form-button
                                icon-name="hi-check-icon"
                                icon-position="right"
                                color="info"
                                type="submit">
                                {{ $t('labels.save') }}
                            </hts-form-button>

                            <hts-form-button
                                color="white"
                                icon-name="hi-x-mark-icon"
                                icon-position="right"
                                disabled="true"
                                @click="closeOverSide">
                                {{ $t('labels.cancel') }}
                            </hts-form-button>
                        </div>

                        <div>
                            <hts-form-button
                                type="text"
                                color="error"
                                icon-name="hi-arrow-path-icon"
                                icon-position="right"
                                @click="undo()">
                                {{ $t('labels.undo') }}
                            </hts-form-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const emits = defineEmits(['close', 'actionAddTypeSupply'])

const closeOverSide = () => {
  emits('close')
}

const rulesFormAddTypeSupply = {
  typeSupplyName: 'required|min:1|max:30',
  description: 'required'
}

const _initForm = {
  typeSupplyName: '',
  description: ''
}

const dataFormAddTypeSupply = reactive({ ..._initForm })

const handleSubmitFormAddTypeSupply = () => {
  const api = {
    url: '/supply/type',
    method: 'post'
  }

  const form = {
    name: dataFormAddTypeSupply.typeSupplyName,
    description: dataFormAddTypeSupply.description
  }

  $api(api, { body: new URLSearchParams(form) })
    .then((data) => {
      const resData: any = data.data.value
      const resError: any = data.error

      if (resData) {
        if (resData.success) {
          const newTypeSupply = resData.meta
          Object.assign(dataFormAddTypeSupply, { ..._initForm })
          emits('actionAddTypeSupply', newTypeSupply)
          process.client && $toast().success(resData.data)
          emits('close')
        }
      } else if (resError.value.data === undefined) {
        process.client && $toast().error($t('labels.canNotConnectServer'))
      } else {
        process.client && $toast().error(resError.value.data.errors[0].msg)
      }
    })
    .catch(() => {
      process.client && $toast().error($t('labels.canNotConnectServer'))
    })
}

const undo = () => {
  Object.assign(dataFormAddTypeSupply, { ..._initForm })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
